import Modal from '../../../common/components/modal/modal';

import '../styles/breakdown.css';

// What somebody reads before authorizing a selection — as a modal, and short.
//
// IT IS ATOMIC, AND THAT IS THE FIRST THING IT SAYS. If one row cannot be
// authorized, none is. A screen that said "3 of 5 authorized" after a failure
// would be describing something that cannot happen.
//
// THE MINIMUM: how many, the tier revision, and — only when there is one — what
// the backend will refuse. The rows were read on the page behind; the list here
// is the ids and titles that travel, cut after a few so the question stays a
// question.

const SHOWN = 5;

export default function AuthorizeConfirm({ tasks, offPage, revision, busy, onCancel, onConfirm }) {
    const blocked = tasks.filter(
        task => task.open_questions?.length > 0 || !task.acceptance_criteria?.length,
    );
    const count = tasks.length + (offPage > 0 ? offPage : 0);

    return (
        <Modal
            open
            title={`Autorizar ${count} tarea${count === 1 ? '' : 's'}`}
            busy={busy}
            onClose={onCancel}
            actions={(
                <>
                    <button type="button" className="breakdown__button" onClick={onCancel} disabled={busy}>
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="breakdown__button breakdown__button--primary"
                        onClick={onConfirm}
                        disabled={busy || count === 0}
                        autoFocus
                    >
                        {busy ? 'Autorizando...' : `Autorizar ${count}`}
                    </button>
                </>
            )}
        >
            <dl className="modal__facts">
                <div>
                    <dt>Tareas</dt>
                    <dd>{count}</dd>
                </div>
                <div>
                    <dt>Revisión del tier</dt>
                    <dd>{revision ?? '—'}</dd>
                </div>
            </dl>

            <ul className="breakdown__summary-list">
                {tasks.slice(0, SHOWN).map(task => (
                    <li key={task.id}>
                        <span className="breakdown__summary-id">#{task.id}</span> {task.title}
                    </li>
                ))}
                {tasks.length > SHOWN && <li>y {tasks.length - SHOWN} más</li>}
                {offPage > 0 && <li>{offPage} seleccionada{offPage === 1 ? '' : 's'} en otra página</li>}
            </ul>

            {blocked.length > 0 && (
                <p className="modal__warn">
                    {blocked.length} {blocked.length === 1 ? 'tiene' : 'tienen'} dudas abiertas o
                    {' '}{blocked.length === 1 ? 'está' : 'están'} sin criterios: el backend va a
                    rechazar el lote entero.
                </p>
            )}

            <p className="modal__note">
                Si alguna no se puede autorizar, no se autoriza ninguna.
            </p>
        </Modal>
    );
}
